import React, { Component } from "react"

import contentLoader from "./content-loader-hoc"

import { randomInt, range } from "../../../config/util-functions"
import { getNoOfLines } from './content-loader-utils'

class ContentLoaderLines extends Component {
    constructor(props) {
        super(props)
        const noOfLines = getNoOfLines(props)
        this.state = {
            lineLengths: range(noOfLines).map(
                _ =>
                    props.lineLength ||
                    randomInt(props.minLineLength, props.maxLineLength + 1)
            )
        }
    }

    render() {
        const { lineLengths } = this.state
        const { className } = this.props
        return lineLengths.map((length, index) => (
            <div
                key={index}
                className={`shadow-line ${className}`}
                style={{ width: `${length}%` }}
            />
        ))
    }
}

ContentLoaderLines.defaultProps = {
    minLineLength: 70,
    maxLineLength: 100,
    lines: 1
}

export default contentLoader(ContentLoaderLines)
